<template>

  <div class="vz-select" :class="{ 'vz-field-filled': optionSelected !== null }">
    <div class="vz-select-content">
      <label :for="'#' + id">{{ label }}</label>
      <div class="vz-select-field">
        <span class="vz-select-value">{{ optionSelected ? optionSelected.label || placeholder : placeholder }}</span>
        <select v-model="optionValue" :id="id" @change="dispatchInput">
          <option v-for="opt in options" :value="opt.value || ''">{{ opt.label || '' }}</option>
        </select>
        <i class="ic-chevron-down vz-select-field-ic"></i>
      </div>
      <transition>
        <vz-field-message v-if="inputMessage.text" :type="inputMessage.type">{{ inputMessage.text }}</vz-field-message>
      </transition>
    </div>
  </div>

</template>

<script>
import Base from '../vz-base.vue';
import VzFieldMessage from './vz-field-message.vue';

/**
 * Select field.
 * @module VzSelect
 * @param {String} id
 * @param {String} label
 * @param {String} placeholder
 * @param {Array} options List of objects { label: String, value: String }.
 * @param {String} message Message to show along with the field (like validation error).
 * @emits {Event} input
 * @author Lanza
 */
export default {

  name: 'VzSelect',
  extends: Base,
  emits: ['input'],
  components: {
    VzFieldMessage
  },

  props: {
    id: {
      type: String,
      default: '',
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []   // [{ label: String, value: String }]
    },
    message: {
      type: Object,
      default: () => ({
        text: '',
        type: 'info'      // info, error
      }),
      validator: value => value.type && ['info', 'error'].indexOf(value.type) !== -1
    }
  },

  data: () => ({
    optionValue: ''
  }),

  computed: {

    inputMessage: function () {
      return this.message && this.message.text ? this.message : {};
    },

    optionSelected: function () {
      return this.options.find(item => item.value === this.optionValue) || null;
    }

  },

  watch: {

    value: function (newValue) {
      this.optionValue = newValue;
    }

  },

  created: function () {
    this.optionValue = this.value;
  },

  methods: {

    dispatchInput: function () {
      this.$emit('input', this.optionValue);
    }

  }

}
</script>

<style>

.vz-select {
  width: 100%;
  margin: 0 0 32px;
}

.vz-select-field {
  border-style: solid;
  border-width: 1px;
  border-color: var(--primary-color);
  border-radius: 4px;
  padding: 17px 48px 17px 32px;
  background-color: #303030;
  /* background-image: linear-gradient(to top, #202020 0px, #303030 6px, #303030); */
  outline: none;
  color: rgba(255,255,255,0.5);
  width: 100%;
  transition-property: border-color, color, box-shadow;
  transition-duration: 0.3s;
  box-shadow: -6px 1px 48px rgba(0,0,0,1);
  position: relative;
}

.vz-select-field:hover {
  border-color: var(--primary-color-over);
}

.vz-select-field:active,
.vz-select-field:focus
{
  border-color: var(--primary-color-active);
  color: #ffffff;
  box-shadow: -6px 1px 32px var(--primary-color-active);
}

.vz-select-value {
  display: block;
  font-family: inherit;
  font-size: 1em;
  line-height: 1em;
  overflow: hidden;
  white-space: nowrap;
}

.vz-select-field select {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.vz-select-field-ic {
  font-size: 1em;
  color: var(--primary-color);
  position: absolute;
  right: 24px;
  top: 50%;
  margin-top: -0.5em;
}


</style>
